import { render, staticRenderFns } from "./EditarResultadoC3FormComponent.vue?vue&type=template&id=ef7e9bba&scoped=true"
import script from "./EditarResultadoC3FormComponent.vue?vue&type=script&lang=js"
export * from "./EditarResultadoC3FormComponent.vue?vue&type=script&lang=js"
import style0 from "./EditarResultadoC3FormComponent.vue?vue&type=style&index=0&id=ef7e9bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7e9bba",
  null
  
)

export default component.exports